(function(){
  function init(){
    var enquiry=document.getElementById('ContactMessage');
    var selectedSet=new URLSearchParams(window.location.search).get('set');
    var setNames={corvatsch:'Corvatsch ski set',eager:'Eiger ski set'};
    if(enquiry&&!enquiry.value&&setNames[selectedSet]) enquiry.value='I would like to enquire about the '+setNames[selectedSet]+'.';

    document.querySelectorAll('.hero video,.product-studio-film video').forEach(function(video){
      video.controls=false;video.removeAttribute('controls');video.muted=true;video.playsInline=true;video.setAttribute('playsinline','');
      var hero=video.closest('.hero');
      var holder=hero||video.closest('.product-studio-film');
      var toggle=hero?hero.querySelector('[data-film-toggle]'):video;
      if(!toggle)return;
      if(!hero){toggle.setAttribute('role','button');toggle.tabIndex=0;}
      var labels=hero?toggle.dataset:holder.dataset;
      function sync(){var label=video.paused?labels.play:labels.pause;toggle.setAttribute('aria-label',label);var text=toggle.querySelector('.sr-only');if(text)text.textContent=label;}
      function change(){if(video.paused){video.play().catch(sync);}else{video.pause();}}
      video.addEventListener('play',sync);video.addEventListener('pause',sync);video.addEventListener('ended',sync);
      toggle.addEventListener('click',change);
      if(!hero)toggle.addEventListener('keydown',function(event){if(event.key==='Enter'||event.key===' '){event.preventDefault();change();}});
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)video.pause();
      sync();
    });
    var header=document.querySelector('.site-header');
    if(header){
      var lastHeaderY=Math.max(0,window.scrollY),headerFrame=0;
      var onScroll=function(){
        headerFrame=0;
        var y=Math.max(0,window.scrollY);
        header.classList.toggle('scrolled',y>45);
        if(!window.matchMedia('(max-width:850px)').matches){header.classList.remove('header-hidden');header.removeAttribute('inert');lastHeaderY=y;return;}
        var hidden=header.classList.contains('header-hidden');
        var firstHero=document.body.classList.contains('is-home')?document.querySelector('main .hero'):null;
        if(firstHero){hidden=firstHero.getBoundingClientRect().bottom<=header.offsetHeight;}
        else if(y<=header.offsetHeight){hidden=false;}
        else if(Math.abs(y-lastHeaderY)>5){hidden=y>lastHeaderY;}
        if(header.contains(document.activeElement)||header.querySelector('details[open]'))hidden=false;
        header.classList.toggle('header-hidden',hidden);
        header.toggleAttribute('inert',hidden);
        if(Math.abs(y-lastHeaderY)>5||y<=header.offsetHeight)lastHeaderY=y;
      };
      var queueHeader=function(){if(!headerFrame)headerFrame=window.requestAnimationFrame(onScroll);};
      onScroll();window.addEventListener('scroll',queueHeader,{passive:true});window.addEventListener('resize',queueHeader);window.addEventListener('pageshow',queueHeader);
      header.querySelectorAll('details').forEach(function(detail){detail.addEventListener('toggle',function(){header.classList.toggle('menu-active',Boolean(header.querySelector('details[open]')));});});
      document.addEventListener('click',function(e){if(!header.contains(e.target)){header.querySelectorAll('details[open]').forEach(function(d){d.open=false;});}});
    }
    document.querySelectorAll('[data-open-dialog]').forEach(function(button){
      button.addEventListener('click',function(){
        var dialog=document.getElementById(button.dataset.openDialog);
        if(dialog){document.querySelectorAll('dialog[open]').forEach(function(other){if(other!==dialog)other.close();});dialog.showModal();document.body.classList.add('locked');}
      });
    });
    document.querySelectorAll('dialog').forEach(function(dialog){
      dialog.addEventListener('close',function(){document.body.classList.toggle('locked',Boolean(document.querySelector('dialog[open]')));});
      dialog.addEventListener('click',function(event){var rect=dialog.getBoundingClientRect();if(event.target===dialog&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)){dialog.close();}});
      dialog.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){dialog.close();});});
    });
    document.querySelectorAll('[data-product-form]').forEach(function(form){
      var variantInput=form.querySelector('[name="id"]');
      var dataEl=document.getElementById(form.dataset.productData);
      if(!variantInput||!dataEl)return;
      var variants=JSON.parse(dataEl.textContent);
      var button=form.querySelector('[name="add"]');
      var price=document.querySelector('[data-product-price]');
      var quantity=form.querySelector('[name="quantity"]');
      function updateVariant(){
        var variant=variants.find(function(v){return String(v.id)===variantInput.value;});
        if(!variant)return;
        button.disabled=!variant.available;
        button.textContent=variant.available?button.dataset.add:button.dataset.sold;
        if(price){price.textContent=variant.priceFormatted;}
        if(quantity){quantity.min=variant.min||1;quantity.step=variant.increment||1;if(variant.max){quantity.max=variant.max;}else{quantity.removeAttribute('max');}quantity.value=variant.min||1;}
        var url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url);
        if(variant.imageId){var target=document.getElementById('ProductImage-'+variant.imageId);if(target){target.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}}
      }
      variantInput.addEventListener('change',updateVariant);
    });
    document.querySelectorAll('[data-sort-form] select').forEach(function(select){select.addEventListener('change',function(){select.form.requestSubmit();});});
    document.querySelectorAll('[data-image-target]').forEach(function(button){button.addEventListener('click',function(){var target=document.getElementById(button.dataset.imageTarget);if(target)target.scrollIntoView({behavior:'smooth',block:'center'});});});
    document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.desktop-nav details[open]').forEach(function(d){d.open=false;});}});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

(function(){
  function initCardSwitches(root){
    root.querySelectorAll('[data-card-switch]').forEach(function(button){
      if(button.dataset.switchReady)return;
      button.dataset.switchReady='true';
      var frames=button.querySelectorAll('[data-card-frame]');
      if(frames.length!==2)return;
      var second=false;
      function sync(){
        frames[0].hidden=second;
        frames[1].hidden=!second;
        button.setAttribute('aria-pressed',String(second));
        button.setAttribute('aria-label',second?button.dataset.firstLabel:button.dataset.nextLabel);
      }
      sync();
      button.addEventListener('click',function(){second=!second;sync();});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initCardSwitches(document);});
  else initCardSwitches(document);
  document.addEventListener('shopify:section:load',function(event){initCardSwitches(event.target);});
})();
